"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var VolumeSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M15,5.5 C15,6.33369727 15,8.50036393 15,12 C15,12.5128358 14.6065571,13 14,13 C12.3675223,13 3.5,13 3.5,13 C3.04315186,13 2.79148865,12.3950958 3.23156225,12.0781693 C3.78345074,11.7208598 7.45011741,9.38752642 14.2315623,5.07816926 C14.6355133,4.84864807 15,5.16239929 15,5.5 Z M14,6.41083658 L10.9999369,8.319 L10.9999369,12 L14,12 L14,6.41083658 Z" })));
};
VolumeSmall.displayName = 'VolumeSmall';
exports.default = VolumeSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=VolumeSmall.js.map